import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Auth.css';
import '../Clients.css';

// Componenta pentru pagina de Login
export default function LoginPage() {
  const navigate = useNavigate(); // Hook pentru navigare
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // { type: 'error'|'success', text: string }
  const [countdown, setCountdown] = useState(null); // Countdown timer pentru rate limiting
  const [isBlocked, setIsBlocked] = useState(false); // Flag pentru a bloca butonul

  // Effect pentru countdown timer
  useEffect(() => {
    if (countdown === null || countdown <= 0) {
      setIsBlocked(false);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setIsBlocked(false);
          setMessage(null);
          return null;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  // Funcția care se ocupă de trimiterea formularului
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      // Apelăm API-ul de login de pe serverul Flask
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Verificăm dacă este eroare de rate limiting (429)
        if (response.status === 429) {
          const retryAfter = data.retry_after || 120;
          setCountdown(retryAfter);
          setIsBlocked(true);
          setLoading(false);
          // Mesajul va fi afișat prin countdown
          return;
        }

        // Dacă serverul returnează o eroare (ex: 401 Unauthorized)
        if (response.status === 401) {
          throw new Error('Utilizator sau parolă incorectă. Vă rugăm să încercați din nou.');
        }
        throw new Error('A apărut o eroare la autentificare. Vă rugăm să încercați din nou.');
      }

      // Login cu succes
      localStorage.setItem('accessToken', data.access_token);
      setMessage({ type: 'success', text: 'Autentificare reușită! Vei fi redirecționat...' });

      // Redirecționează către hub-ul de validare după 1 secundă
      setTimeout(() => {
        navigate('/validation-hub');
      }, 1000);

    } catch (error) {
      setMessage({ type: 'error', text: error.message });
      setLoading(false); // Oprește indicatorul de încărcare în caz de eroare
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-header-icon"><span className="auth-header-icon-dot" /></span>
          <h1 className="auth-title">Autentificare</h1>
          <p className="auth-subtitle">Introduceți credențialele pentru a accesa panoul</p>
        </div>
        <div className="auth-content">
          <form onSubmit={handleLogin} className="auth-form-inner">
            <div className="auth-field">
              <label htmlFor="username" className="auth-label">Utilizator</label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                className="clients-input auth-input"
                placeholder="Nume utilizator"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="auth-field">
              <label htmlFor="password" className="auth-label">Parolă</label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="clients-input auth-input"
                placeholder="Parolă"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
            </div>

            {/* Afișăm countdown-ul dacă este blocat */}
            {countdown !== null && countdown > 0 && (
              <div className="auth-alert auth-alert-error">
                <strong>Ați încercat de prea multe ori!</strong>
                <br />
                Vă rugăm reîncercați în: <strong>{Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, '0')}</strong> minute
              </div>
            )}

            {/* Afișăm mesajele normale (erori sau succes) */}
            {message?.text && countdown === null && (
              <div className={`auth-alert ${message.type === 'error' ? 'auth-alert-error' : 'auth-alert-success'}`}>
                {message.text}
              </div>
            )}

            <div className="auth-actions">
              <button
                type="submit"
                className="review-btn auth-submit"
                disabled={loading || isBlocked}
              >
                {isBlocked
                  ? `Blocat (${Math.floor(countdown / 60)}:${String(countdown % 60).padStart(2, '0')})`
                  : loading
                    ? 'Se autentifică...'
                    : 'Intră în cont'
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
